export const paymentMainSection = `<p>
<p>Lloyds Bank Gem Connect allows you to make several types of payments: Faster Payments, BACS, CHAPS, SEPA Credit Transfers and International Payments. Inter-Account Transfers can also be used to manage funds between internal Gem Connect accounts.</p>
<p>For Multibank accounts you hold with other institutions, Requests for Transfer (MT101) can be made to make payments from these relevant accounts. Financial Institutions may also be able to initiate FI to FI transfers.</p>
<p>A number of controls need to be put into place before you can make <u>and approve </u>payments and they are covered in the table below. Please note that as a default every payment (except Inter Account Transfers)<b> must</b> be approved by a different user from whoever created the payment.</p>
</p>
<table class='table table-bordered'>
<thead>
<tr>
<td>Activity</td><td>Description</td><td>Section</td>
</tr>
</thead>
<tbody>
<tr><td>Role Profiles</td>
<td>Each User is assigned to a specific role profile that must have payment entitlements enabled at set up </td>
<td>Role Profiles and Users section
</td></tr>
<tr><td>Accounts</td>
<td>Each User must have appropriate accounts linked to their profile to support debit activity when raising a payment request </td>
<td>Role Profiles and Users section</td></tr>
<tr><td>Payment Workflow</td><td>Transactional value approval limits must be applied to either individual users and/or a group of users (see approval groups below). The limits can be set against individual payment types and/or all payment types. If a limit is set for all payment types and a different limit is set against a specific payment type, then the approval rules will always default to the individual payment type where they exist, if not then it will use the generic payment type rule</td>
<td>Payment workflow & approval chain section</td></tr>
<tr><td>Approval Chains</td><td>Individuals and/or Approval Groups can be applied per payment type (or all payment types)</td><td>Payment workflow & approval chain section</td></tr>
<tr><td>Approval Groups</td><td>Approval Groups can be created with any number of individual users and assigned to an Approval Chain per payment type (or all payment types). An individual user can feature in more than one approval group.</td>
<td>Payment approval groups section</td></tr>
<tr><td>Beneficiary Groups</td><td>Individuals can be assigned to a Beneficiary User Group which will restrict the number of beneficiaries that they can use when creating payment requests</td>
<td>Beneficiary user groups section</td></tr>
</tbody>
</table>

`;


// WEBPACK FOOTER //
// ./src/components/content/payments/paymentHead.ts